import React, { useEffect } from "react";
import { Button } from "@mui/material";

import "./botonera.scss";

const isSelectMenuOpen = () => {
  return Boolean(
    document.querySelector(
      [
        '[role="listbox"]',
        '[role="option"]',
        '.MuiMenu-paper',
        '.MuiPopover-root .MuiMenu-list',
        '[aria-haspopup="listbox"][aria-expanded="true"]',
      ].join(",")
    )
  );
};

const Guardar = ({
  handleSubmit,
  loading,
  id,
  texto_confirmar,
  size,
  submitOnEnter = true,
  buttonId = "abm_boton_guardar",
}) => {

  useEffect(() => {
    if (!submitOnEnter) return;
  
    const handleKeyDown = (e) => {
      if (e.defaultPrevented) return;
      if (e.key?.toLowerCase() === "enter") {
        if (isSelectMenuOpen()) return;
       return document.getElementById(buttonId)?.click();
      }
    };
  
    document.addEventListener("keydown", handleKeyDown);
  
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [buttonId, submitOnEnter]);
  
  return (
    <>
      <Button
        id={buttonId}
        variant="contained"
        color={id ? "primary" : "secondary"}
        size={size ?? "medium"}
        onClick={handleSubmit}
        disabled={loading}
        style={{ width: "100px", marginRight: "20px" }}
        className="btn-guardar"
      >
        {texto_confirmar ?? (id ? "Guardar" : "Crear")}
      </Button>
    </>
  );
};

export default Guardar;
